import { useEffect, useState } from "react";
import { fetchCustomerTypes, downloadCustomerTypesExcel } from "../Api/ViewCustomerType";
import { Container, Table, Button } from "react-bootstrap";
import { toast } from "react-toastify";
import moment from "moment";

const ViewCustomerType = () => {
  const [customerTypes, setCustomerTypes] = useState([]);
  const [isDownloading, setIsDownloading] = useState(false);

  useEffect(() => {
    const loadCustomerTypes = async () => {
      try {
        const data = await fetchCustomerTypes();
        setCustomerTypes(data || []);
      } catch (error) {
        toast.error(`🦄 Error Fetching Customer Types`);
      }
    };

    loadCustomerTypes();
  }, []);

  const handleDownload = async () => {
    setIsDownloading(true);
    try {
      const response = await downloadCustomerTypesExcel();
      
      if (!response.data) {
        throw new Error("No data received from server");
      }
      
      // Create download link
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', 'CustomerTypes_Data.xlsx');
      
      // Trigger download
      document.body.appendChild(link);
      link.click();
      
      // Cleanup
      setTimeout(() => {
        window.URL.revokeObjectURL(url);
        link.parentNode.removeChild(link);
      }, 100);
      
      toast.success("Customer Types data download started!");
    } catch (error) {
      console.error("Download error:", error);
      toast.error(`🦄 Download failed: ${error.message}`);
    } finally {
      setIsDownloading(false);
    }
  };

  return (
    <>
      
        <div className="main-content expand">
          <Container fluid className="list-container">
            <div className="d-flex justify-content-between align-items-center mb-3">
              <h2 className="list-title">View Customer Types</h2>
              <Button 
                className="generate-btn"
                variant="primary" 
                onClick={handleDownload}
                disabled={isDownloading || customerTypes.length === 0}
              >
                {isDownloading ? 'Downloading...' : 'Download Data'}
              </Button>
            </div>

            {customerTypes.length > 0 ? (
              <Table bordered hover responsive className="data-table">
                <thead>
                  <tr>
                    <th>#</th>
                    <th>Customer Type ID</th>
                    <th>Code</th>
                    <th>Description</th>
                    <th>Created On</th>
                    <th>Created By</th>
                    <th>Changed On</th>
                    <th>Changed By</th>
                  </tr>
                </thead>
                <tbody>
                  {customerTypes.map((type, index) => (
                    <tr key={index}>
                      <td>{index + 1}</td>
                      <td>{type.customer_Type_ID}</td>
                      <td>{type.code}</td>
                      <td>{type.description}</td>
                      <td>
                        {moment(type.createdOnDate).format('L')} at {type.createdOnTime?.substring(0, 8)}
                      </td>
                      <td>{type.createdBy}</td>
                      <td>
                        {type.changedOnDate ? 
                          `${moment(type.changedOnDate).format('L')} at ${type.changedOnTime?.substring(0, 8)}` : 
                          'N/A'}
                      </td>
                      <td>{type.changedBy || 'N/A'}</td>
                    </tr>
                  ))}
                </tbody>
              </Table>
            ) : (
              <p className="no-data">No customer types found.</p>
            )}
          </Container>
        </div>
      
    </>
  );
};

export default ViewCustomerType;